import { Button, Container, Grid, useMediaQuery } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";
import WebIcon from "@material-ui/icons/Web";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import registrationPackage from "../../../../assets/documents/registrationPackage.zip";
import proTip1 from "../../../../assets/images/protip_paybill_1.png";
import { getToken } from "../../../../middleware/storage";
import YoozAccordion from "../../components/yoozAccordion";
import { setTabPosition } from "../../uiSlice";

const useStyles = makeStyles((theme) => ({
  paper: {
    flexGrow: 1,
    width: "100%",
    marginTop: theme.spacing(5),
  },
  img: {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "75%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
  },
}));

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function FAQContent() {
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const md = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  let accCount = 0;

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const token = getToken();

  return (
    <Container>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="secondary"
        textColor="secondary"
        variant={sm ? "scrollable" : "standard"}
        scrollButtons="on"
        centered={sm ? false : true}
      >
        <Tab
          label={<Typography variant={md ? "body1" : "h6"}>GENERAL</Typography>}
          {...a11yProps(0)}
        />
        <Tab
          label={
            <Typography variant={md ? "body1" : "h6"}>REGISTERING</Typography>
          }
          {...a11yProps(1)}
        />
        <Tab
          label={
            <Typography variant={md ? "body1" : "h6"}>PAY BILLS</Typography>
          }
          {...a11yProps(2)}
        />
        <Tab
          label={<Typography variant={md ? "body1" : "h6"}>TOP UP</Typography>}
          {...a11yProps(3)}
        />
        <Tab
          label={
            <Typography variant={md ? "body1" : "h6"}>GET PAID</Typography>
          }
          {...a11yProps(4)}
        />
      </Tabs>
      <Paper className={classes.paper}>
        <TabPanel value={value} index={0}>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What is YOOZ? "
          >
            If you ask our customers and partners, they’d say it’s the best
            mobile payment service in T&T! <br />
            <br />
            <b>YOOZ</b> is actually the first fully secure <b>mobile</b> payment
            platform that lets you top up and pay bills directly from any debit
            or credit card. We also recently launched our online bill payment
            service.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What services can I access on YOOZ? "
          >
            <b>YOOZ Mobile</b> <br />
            You can top up your mobile phone or someone else’s on the same
            network. You can also pay bills and invoices for a variety of
            utilities and merchants.
            <br />
            <br />
            <b>YOOZ Online</b> <br />
            You can top up and pay bills using the Quick Pay option, no sign up
            necessary, or you or you can sign up and create a secure account.
            From your secure account, you can make payments and save your card
            details so you don’t need to remember them next time.
            <br />
            <br />
            We’re always adding new utilities and merchants, so stay tuned!
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Are there any fees for using YOOZ? "
          >
            <b>YOOZ</b> is free to <b>YOOZ</b>! Depending on your financial
            institution, bank charges may apply.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Can I use any mobile phone? "
          >
            Yes, <b>YOOZ</b> works on all mobile phones.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What happens if I get a new mobile phone? "
          >
            Once your phone number remains the same, you can <b>YOOZ</b> it. If
            you get a new phone number, just{" "}
            <Button
              onClick={() => {
                window.scrollTo(0, 0);
                dispatch(setTabPosition(6));
              }}
              component={RouterLink}
              to={token ? "/user/contactus" : "/contact"}
              color="primary"
              size="small"
            >
              Contact us
            </Button>
            .
          </YoozAccordion>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Where do I register for YOOZ? "
          >
            <Grid container>
              <Grid item xs={12}>
                <Button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(setTabPosition(7));
                  }}
                  component={RouterLink}
                  to="/signup"
                  color="primary"
                  startIcon={<WebIcon />}
                >
                  Online
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(setTabPosition(7));
                  }}
                  component={RouterLink}
                  to={token ? "/user/contactus" : "/contact"}
                  color="primary"
                  startIcon={<DirectionsRunIcon />}
                >
                  In person. Find the location nearest you.
                </Button>
              </Grid>
            </Grid>
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What do I need to register or sign-up for YOOZ? "
          >
            To register, you need:
            <ul>
              <li>Phone Number</li>
              <li>Debit Card or Credit Card</li>
              <li>A form of ID</li>
            </ul>
            There’s no application form so it takes less than 2 minutes.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What do I need to register or sign-up for YOOZ Online?"
          >
            To register online, you need:
            <ul>
              <li>Email Address</li>
              <li>Phone Number</li>
              <li>Visa Debit Card or AnyCredit Card</li>
            </ul>
            Just follow the steps and you’re good to go.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Can I register multiple bank cards to my phone number? "
          >
            Only one card can be registered to a phone number.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Can I register multiple phone numbers and/or bill pay accounts to one bank card? "
          >
            Yes!
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What if my bank card expires and I need to change it?"
          >
            Simply register the new card.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How do I know my registration is complete? "
          >
            You’ll get a confirmation message via SMS or online once your
            registration is successful.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How do I unregister for YOOZ? "
          >
            <Button
              onClick={() => {
                window.scrollTo(0, 0);
                dispatch(setTabPosition(6));
              }}
              component={RouterLink}
              to={token ? "/user/contactus" : "/contact"}
              color="primary"
              size="small"
            >
              Contact us
            </Button>{" "}
            Once we confirm your identity, you’ll be unregistered.
          </YoozAccordion>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What is YOOZ Bill Pay? "
          >
            <b>YOOZ</b> Bill Pay gives customers the convenience to pay bills
            from their phone or online.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How to add a Bill Pay Account on YOOZ Mobile?"
          >
            Dial *190# <br />
            Enter 3 - Pay Bills. <br />
            Select the payee (bill you want to pay). <br />
            Enter your account number or select saved account. <br />
            Enter payment amount. <br />
            Enter <b>YOOZ passcode</b>. <br />
            You'll get a success message and a confirmation SMS once your
            payment is successful. <br />
            <br />
            <img
              src={proTip1}
              alt="yooz topup protip"
              className={classes.img}
            />
            ,
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How do I pay bills with YOOZ Online? "
          >
            <Button
              onClick={() => {
                window.scrollTo(0, 0);
                dispatch(setTabPosition(7));
              }}
              component={RouterLink}
              to={token ? "/user/billpay" : "/quickpay"}
              color="primary"
              size="small"
              variant="contained"
            >
              Quick Pay
            </Button>
            <br />
            <br />
            No need to register! Just follow the steps to enter your information
            and you’re done!
            <br /> <br />
            <Button
              onClick={() => {
                window.scrollTo(0, 0);
                dispatch(setTabPosition(7));
              }}
              component={RouterLink}
              to="/signup"
              color="primary"
              size="small"
              variant="contained"
            >
              Online
            </Button>
            <br />
            <br />
            Sign up to create a <b>YOOZer</b> account and save your details so
            you don’t have to remember them next time.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Is there a minimum or maximum amount I can pay on a bill?"
          >
            Minimum payment per transaction – $25 <br />
            Maximum payment daily – $5,000 per utility <br />
            Maximum payment monthly – $10,000 per utility <br />
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="When will the payment be applied to my account?"
          >
            The payment will be applied to your account within one working day
            and you can contact your service provider to confirm.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Can I pay someone else’s bill? "
          >
            Yes!
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What if I accidentally paid the wrong bill? "
          >
            Contact the payee as soon as possible and they will be able to
            assist you.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How will I know if my transaction was successful?"
          >
            You'll receive a transaction receipt via SMS for mobile transactions
            and email for online transactions.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="If a transaction fails, can I try again?"
          >
            Yes. Ensure you have funds on your card and enter the correct{" "}
            <b>YOOZ passcode</b>. If you enter the incorrect passcode 3 times in
            a row, your account will be blocked and you’ll need to re-register.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How do I delete a Bill Pay Account on YOOZ Mobile? "
          >
            Dial *190# <br />
            Enter 4 - My Account. <br />
            Enter 4 - Manage Bill Payments. <br />
            Enter 2 - Delete Account. <br />
            Select the chosen payee (bill you want to stop paying) <br />
            Enter <b>YOOZ passcode</b>. <br />
            You’ll get a confirmation message once the account is deleted.{" "}
            <br />
          </YoozAccordion>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What is YOOZ Top Up? "
          >
            <b>YOOZ</b> Top Up lets prepaid and postpaid mobile phone customers
            Top Up their credit or someone else’s directly from their phone or
            device.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How do I Top Up with YOOZ Mobile?"
          >
            Dial *190# <br />
            Enter 1 - Top Up My Phone or 2 - Top Up Other Phone. <br />
            Enter Top Up amount. <br />
            If Option 2 was selected, enter other mobile number <br />
            Enter 1 to confirm, then your <b>YOOZ passcode</b> <br />
            You'll get a success message and a confirmation SMS once your Top Up
            is successful. <br />
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Is there a Top Up short code for YOOZ Mobile?"
          >
            Dial *190*top up amount#” e.g. *190*30# and press send. <br />
            Enter 1 to confirm the amount of Top Up and press send <br />
            Enter your <b>YOOZ passcode</b> and press send. <br /> <br />
            You'll get a success message and a confirmation SMS once your Top Up
            is successful.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How do I Top Up with YOOZ Online?"
          >
            <Button
              onClick={() => {
                window.scrollTo(0, 0);
                dispatch(setTabPosition(7));
              }}
              component={RouterLink}
              to={token ? "/user/topup" : "/quicktopup"}
              color="primary"
              size="small"
              variant="contained"
            >
              Quick Pay
            </Button>
            <br />
            <br />
            No need to register! Just follow the steps to enter your information
            and you’re done!
            <br /> <br />
            <Button
              onClick={() => {
                window.scrollTo(0, 0);
                dispatch(setTabPosition(7));
              }}
              component={RouterLink}
              to="/signup"
              color="primary"
              size="small"
              variant="contained"
            >
              Online
            </Button>
            <br />
            <br />
            Sign up to create a <b>YOOZer</b> account and save your details so
            you don’t have to remember them next time.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Is there a minimum or maximum Top Up that I can purchase?"
          >
            Minimum Top Up per transaction – $30 <br />
            Maximum Top Up per transaction – $200 <br />
            Maximum Top Up per day – $500 <br />
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Can I Top Up someone else’s phone?"
          >
            Yes, you can top up someone else’s phone by selecting the “Top up
            other phone” from the <b>YOOZ</b> menu on Mobile or entering their
            phone number online. The receiver must be on the same mobile carrier
            network as you when using Yooz Mobile.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="What if I accidentally topped up the wrong number?"
          >
            We advise you to check and double check the number you want to top
            up. Once you confirm the purchase, the transaction can’t be
            reversed.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How will I know if my transactions were successful?"
          >
            You’ll receive a success message and confirmation SMS with your
            transaction details.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="If a transaction fails, can I try again?"
          >
            Yes. Ensure you have funds on your card and enter the correct{" "}
            <b>YOOZ passcode</b>. If you enter the incorrect passcode 3 times in
            a row, your account will be blocked and you’ll need to re-register.
          </YoozAccordion>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How can I get paid with YOOZ? "
          >
            To register your business with us, you’ll need the following
            documents to start: <br />
            <br />
            - Business registration documents <br />
            - Business Bank account information <br />
            - Utility bill and IDs <br />
            <br />
            <Button
              component={"a"}
              href={registrationPackage}
              color="primary"
              size="small"
              variant="contained"
            >
              Download Registration Package
            </Button>
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How do I know when customers pay me? "
          >
            <b>YOOZ</b> provides transaction reports of all payments made to you
            by your customers. <br />
            <br />
            You can also encourage them to send you a screen shot of their
            receipt. <br />
            <br />
            If you have an online portal, <b>YOOZ</b> can integrate with you to
            automatically apply payments to customers’ accounts and invoices.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How long do transactions take to process? "
          >
            <b>YOOZ</b> processes transactions in real time.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How does my business receive transaction reports?"
          >
            API: Real time. <br />
            FTP: Every 15 minutes. <br />
            Transaction Reports: As required.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="How long does it take to receive settlements from YOOZ?"
          >
            2 to 5 business days.
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="If I don’t have a website, can I still register my business with YOOZ? "
          >
            Yes!
          </YoozAccordion>
        </TabPanel>
        {/* <TabPanel value={value} index={4}>
          <Typography variant={md ? "h5" : "body11"}>
            Depending on the type of support you need, there are a variety of
            options to choose from. <br /> <br />
          </Typography>
          <YoozAccordion id={"accordionID" + accCount++} summary="Resonance">
            868.235.6185 8 a.m. to 5.p.m. Monday to Friday
            <br />
            Service deactivation <br />
            YOOZ transactions <br />
            Unapplied payments <br />
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Utility Partner"
          >
            Flow 225 3569 | GreenDot 224 4368 <br />
            Utility account inquiries <br />
            Late application of payments <br />
            Unapplied payments <br />
            Payment made to incorrect utility account <br />
          </YoozAccordion>
          <YoozAccordion
            id={"accordionID" + accCount++}
            summary="Mobile Network Operator"
          >
            Digicel 100 | Bmobile *100 <br />
            Service deactivation <br />
            Top Up promotions <br />
          </YoozAccordion>

          <br />
          <Typography variant={md ? "h5" : "body11"}>
            Resonance, YOOZ and our YOOZ Partners will attempt to resolve the
            issue and communicate the resolution to you. Any issues in relation
            to your bank account must be referred to your banking institution.
          </Typography>
        </TabPanel> */}
      </Paper>
    </Container>
  );
}
